// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NodeIndexOutlinedSvg from "@fishx/icons-svg/es/asn/NodeIndexOutlined";
import FishxIcon from '../components/FishxIcon';

var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NodeIndexOutlinedSvg
  }));
};

NodeIndexOutlined.displayName = 'NodeIndexOutlined';
export default React.forwardRef(NodeIndexOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NodeIndexOutlined.js
// module id = 3174
// module chunks = 0